import React, { Fragment, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { Button } from 'rsuite'

export default function EmailVerificationComponent({userDetails,handleChange,handleOnSubmitSendVerification,handleOnSubmitVerifyVerification}) {

const [isSendVerification, setIsSendVerification] = useState(false);
const [enterdEmail,setEnterdEmail] = useState("");
  const [validated, setValidated] = useState(false);

const [errors, setErrors] = useState({
    email: '',
   
  });

const changeIsSendVerification = (event) => {
    setErrors({
      ...errors,
      ["email"]: '',
    });
    if(enterdEmail == userDetails?.email){
        setIsSendVerification(true);
        handleOnSubmitSendVerification();
    }
    event.preventDefault();
        if (validateForm()) {
           
        setValidated(true);
        } else {
        setValidated(false);
        }
    
}
const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (enterdEmail === "" || enterdEmail == null) {
      valid = false;
      newErrors.email = 'Enter Emaiil';
    }

    if ((enterdEmail !== "" || enterdEmail !== null) && userDetails.email !== enterdEmail) {
      valid = false;
      newErrors.email = 'Invalid email';
    }
    setErrors(newErrors);
    return valid;

  };
    const onSubmitAction = () => {
        handleOnSubmitVerifyVerification();
    }

  return (
    <Fragment>
                    
                                <Form noValidate validated={validated} onSubmit={changeIsSendVerification}>
                                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                        <Form.Label column sm={3}>
                                        Email Address
                                        </Form.Label>
                                        <Col sm={9}>
                                        <Form.Control isInvalid={!!errors.email} name='email' onChange={(val)=> setEnterdEmail(val.target.value)} type="email" disabled={!isSendVerification ? false : true} placeholder="Email Address" />
                                        <p style={{ color:"red",fontSize:12 }}>{errors.email}</p>
                                        </Col>
                                    </Form.Group>

                                        <Form.Group as={Row} className="mb-3">
                                            <Col>
                                                {/* Empty space to push the button to the end */}
                                            </Col>
                                            <Col xs="auto">
                                                <Button disabled={!isSendVerification ? false : true}  style={{ width: '180px', backgroundColor: !isSendVerification ? '#990000' : 'gray' , color: 'white' }} type="submit">Send OTP</Button>
                                            </Col>
                                        </Form.Group>

                                    </Form>
                        
                    

                        {isSendVerification && (
                            <Form>
                                            <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                <Form.Label column sm={3}>
                                                OTP
                                                </Form.Label>
                                                <Col sm={9}>
                                                <Form.Control onChange={(val)=>handleChange('otp',val.target.value) } name='otp' type="email" placeholder="OTP Code" />
                                                </Col>
                                            </Form.Group>

                                                <Form.Group as={Row} className="mb-3">
                                                    <Col>
                                                        {/* Empty space to push the button to the end */}
                                                    </Col>
                                                    <Col xs="auto">
                                                        <Button onClick={onSubmitAction} style={{ width: '180px', backgroundColor: '#990000', color: 'white' }} type="button">Verify</Button>
                                                    </Col>
                                                </Form.Group>

                                            </Form>
                        )}
                        
    </Fragment>
  )
}
